module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAABGElEQVR4Xu2asQ3CQAxFfQIRhsgcEBpCGsJIKcIOqaDIDPRMEAkmyjUcisQIn8K6lwEs3z/b91/kYJl/IfPzGwJQAZkrQAtkXgAMQVqAFshcgdC048PMLiklWTtcuzpW+7JQaruaXrEY7sKYKVmyZzidx08I2mHYd8e52pVbpQDr6T1vhps0pi233rRjUia6xHIjgJkhABVACzADGIK8AmIFeAa9GCF8AEYIJ4gVxgpjhbHCWGGxEeSHCFYYK+zkpygsAAvAArAALAALwAKwACwgVgAWgAVgAR8bIsAQMAQMAUOsyf1hUbLv6njwsigpNoHuwsnWY92d/JcwAni9OVXeVIBKSa9xqACvN6fKmwpQKek1TvYV8AU5XX2OWwm8GQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/resources/images/languageflags/fr.png
// module id = 176
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22